<template>
  <div :style="styles.base">
      <!--  滑动展示 头像   -->
    <div v-if="!isShowCarouselType">
          <div
               :class="getCss('scroll-item-club-window')">
               <div
                 :style="scrollItemClubAreaStyle"
                 :class="getCss('scroll-item-club')"
                    v-if="showClubList.length  >0 "
               >
                 <div   :class="getCss('scroll-item-club-show')"
                        v-for="(item,index) in showClubList"
                        :key="index"
                 >
                   <img  alt="" :class="getCss('scroll-item-club-avatar')"
                         :style="clubIconBorderStyle"
                         v-if="item.club_avatar"
                         :src="item.club_avatar" />
                   <span
                     :style="scrollItemClubTextStyle"
                     :class="getCss('scroll-item-club-name')">{{item.club_name}}</span>
                 </div>
               </div>
            <div
              :style="emptyClubTextStyles"
              v-if="!!configurationData.emptyClubText && showClubList.length === 0"
              :class="getCss('scroll-item-empty-text')">
              {{configurationData.emptyClubText}}
            </div>
          </div>
    </div>

    <!-- 轮播模式展示    -->
    <div :class="getCss('club')" v-if="isShowCarouselType">
      <div :class="getCss('section')" :style="trackStyle">
        <div
          v-for="index in pageNum"
          :key="index"
          :class="getCss('section_item')"
        >
          <div :style="showImg(2 * (index-1))">
            <div :class="getCss('club_img')" :style="showClubImg(2 * (index-1))"></div>
            <div :class="getCss('club_name')" :style="textStyles">{{showClubName((2 * (index-1)))}}</div>
          </div>
          <div :style="showImg((2 * (index-1)) + 1)">
            <div :class="getCss('club_img')" :style="showClubImg((2 * (index-1)) + 1)"></div>
            <div :class="getCss('club_name')" :style="textStyles">{{showClubName((2 * (index-1)) + 1)}}</div>
          </div>
        </div>
      </div>
      <!-- 左右按钮 -->
      <div :style="`--arrow-opacity: ${arrowOpacity};`" v-show="hasArrowButton">
        <div
          :style="{ '--leftArrow': leftArrow }"
          :class="getCss('left')"
          @click="add(-1)"
        ></div>

        <div
          class="carousel-arrow"
          :style="{ '--rightArrow': rightArrow }"
          :class="getCss('right')"
          @click="add(1)"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
const DISPLAY_TYPE_CAROUSEL = 'carousel';
// const DISPLAY_TYPE_SCROLL = 'scroll';
export default {
  name: 'CTgclubShowJoinClub',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-show-join-club-',
      imgIndex: 0,
      trackStyle: {},
      hasArrowButton: true,
      arrowOpacity: 1,
      pageNum: 0, // 页数
      imageList: [], // 已加入的俱乐部列表
    };
  },
  computed: {
    showClubList() {
      if (this.$isInEditor) {
        return  (new Array(6).fill(1))
          .map(() => ({
            club_avatar: 'https://game.gtimg.cn/images/js/img/tgclub/tgclubLogo.png',
            club_name: '俱乐部名称',
          }));
      }
      return  this.imageList;
    },
    emptyClubTextStyles() {
      const { width, height } = this.styles.base;
      const { emptyClubTextStyles =  {} } = this.styles;
      return {
        width, height, lineHeight: height, ...emptyClubTextStyles,
      };
    },
    scrollItemClubTextStyle() {
      const { scrollClubTextStyles =  {} } = this.styles;
      const  {  color = '#e8e8e8',
        fontSize = '0.24rem',
        fontFamily = '微软雅黑',

        fontWeight = '500' } = scrollClubTextStyles;
      return { color, fontSize, fontFamily, fontWeight };
    },
    clubIconBorderStyle() {
      const { scrollClubTextStyles =  {} } = this.styles;
      const { borderColor = '#f1cc12' } = scrollClubTextStyles;
      return {
        border: `0.02rem solid ${borderColor}`,
      };
    },
    isShowCarouselType() {
      let { displayType =  DISPLAY_TYPE_CAROUSEL } = this.configurationData;
      displayType = displayType || DISPLAY_TYPE_CAROUSEL;
      return displayType === DISPLAY_TYPE_CAROUSEL;
    },
    scrollItemClubAreaStyle() {
      return {
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    textStyles() {
      return this.styles.textStyles;
    },
    titleStyles() {
      return this.styles.titleStyles;
    },
    leftStyle() {
      // transformOrigin 设置选择的定点
      return { top: '50%', transform: 'translateY(-50%)', left: '8px' };
    },
    rightStyle() {
      return { top: '50%', transform: 'translateY(-50%)', right: '8px' };
    },
    leftArrow() {
      return `url('${this.configurationData.leftArrowImage || 'none'}')`;
    },
    rightArrow() {
      return `url('${this.configurationData.rightArrowImage || 'none'}')`;
    },
    showImg() {
      return function (index) {
        if (index >= this.imageList.length) {
          return {
            display: 'flex',
          };
        }
        if (this.imageList.length % 2 === 1 && index === this.imageList.length - 1) {
          return {
            backgroundImage: `url(${this.configurationData.clubBgImg || ''})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'left',
            width: '100%',
            height: '50%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            marginTop: '0.7rem',
          };
        }
        return {
          backgroundImage: `url(${this.configurationData.clubBgImg || ''})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'left',
          width: '100%',
          height: '50%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          marginTop: '0.05rem',
        };
      };
    },
    showClubImg() {
      return function (index) {
        if (index >= this.imageList.length) {
          return {
            height: '.3rem',
          };
        }
        return {
          backgroundImage: `url(${this.imageList[index].club_avatar || ''})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'left',
          width: '.8rem',
          height: '.8rem',
        };
      };
    },
    showClubName() {
      return function (index) {
        if (index >= this.imageList.length) {
          return '';
        }
        return this.imageList[index].club_name;
      };
    },
  },
  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$isInEditor) return;
      const { initDataType = 1 } = this.configurationData;
      if (initDataType === 1) {
        this.$onLogined(() => {
          if (this.configurationData.getClubListFlowId !== 0) {
            this.getClubInfo();
          }
        });
      } else if (initDataType === 2) {
        this.$onQuaRefreshed(() => {
          this.getClubInfo();
        });
      }
    },
    async getClubInfo() {
      // this.imageList = [1, 2, 3, 4, 5].map(index => ({
      //   avatar: 'https://game.gtimg.cn/images/js/img/tgclub/tgclubLogo.png',
      //   name: `${index}俱乐部名称`,
      // }));
      // return;
      const response = await this.flowRequest({
        flowId: this.configurationData.getClubListFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      const { ret, data = {} } = response;
      if (ret !== 0) {
        return false;
      }
      const { list = '[]' } = data;
      this.imageList = list && list !== 'null' ?  JSON.parse(data.list) : [];
      console.log(this.imageList, 'this.imageList');
      this.pageNum = Math.ceil(this.imageList.length / 2);
    },
    add(offset) {
      const width = Number(this.configurationData.imgWidth) / 100;
      if (offset === 1) {
        if (this.imgIndex >= 0 && this.imgIndex < this.pageNum - 1) {
          this.imgIndex += 1;
          this.trackStyle = {
            transition: 'transform 400ms ease',
            transform: `translateX(-${this.imgIndex * width}rem)`,
          };
          return false;
        }
      }
      if (offset === -1) {
        if (this.imgIndex > 0 && this.imgIndex < this.pageNum) {
          this.imgIndex -= 1;
          this.trackStyle = {
            transition: 'transform 400ms ease',
            transform: `translateX(-${this.imgIndex * width}rem)`,
          };
          return false;
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import "./styles.scss";
</style>
